/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  PortfolioCreateRequest,
  PortfolioRepresentation,
  PortfolioTemplateRepresentation,
  PortfolioUpdateRequest,
} from '../models/index';
import {
    PortfolioCreateRequestFromJSON,
    PortfolioCreateRequestToJSON,
    PortfolioRepresentationFromJSON,
    PortfolioRepresentationToJSON,
    PortfolioTemplateRepresentationFromJSON,
    PortfolioTemplateRepresentationToJSON,
    PortfolioUpdateRequestFromJSON,
    PortfolioUpdateRequestToJSON,
} from '../models/index';

export interface AddGeneratorsToPortfolioRequest {
    key: string;
    requestBody?: Array<string>;
}

export interface CreatePortfolioRequest {
    portfolioCreateRequest: PortfolioCreateRequest;
}

export interface DeletePortfolioByKeyRequest {
    key: string;
}

export interface GetPortfolioByKeyRequest {
    key: string;
}

export interface RemoveGeneratorsRequest {
    key: string;
    requestBody?: Array<string>;
}

export interface UpdatePortfolioRequest {
    key: string;
    portfolioUpdateRequest: PortfolioUpdateRequest;
}

/**
 * 
 */
export class PortfolioApi extends runtime.BaseAPI {

    /**
     * Add a list of generators to a portfolio
     * Add generators
     */
    async addGeneratorsToPortfolioRaw(requestParameters: AddGeneratorsToPortfolioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['key'] == null) {
            throw new runtime.RequiredError(
                'key',
                'Required parameter "key" was null or undefined when calling addGeneratorsToPortfolio().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["portfolios:write"]);
        }


        let urlPath = `/portfolios/by-key/{key}/generators`;
        urlPath = urlPath.replace(`{${"key"}}`, encodeURIComponent(String(requestParameters['key'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Add a list of generators to a portfolio
     * Add generators
     */
    async addGeneratorsToPortfolio(key: string, requestBody?: Array<string>, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.addGeneratorsToPortfolioRaw({ key: key, requestBody: requestBody }, initOverrides);
    }

    /**
     * Create new portfolios for the current user
     * Create portfolio
     */
    async createPortfolioRaw(requestParameters: CreatePortfolioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PortfolioRepresentation>> {
        if (requestParameters['portfolioCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'portfolioCreateRequest',
                'Required parameter "portfolioCreateRequest" was null or undefined when calling createPortfolio().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["portfolios:write"]);
        }


        let urlPath = `/portfolios`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PortfolioCreateRequestToJSON(requestParameters['portfolioCreateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PortfolioRepresentationFromJSON(jsonValue));
    }

    /**
     * Create new portfolios for the current user
     * Create portfolio
     */
    async createPortfolio(portfolioCreateRequest: PortfolioCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PortfolioRepresentation> {
        const response = await this.createPortfolioRaw({ portfolioCreateRequest: portfolioCreateRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Delete portfolio by key
     * Delete portfolio
     */
    async deletePortfolioByKeyRaw(requestParameters: DeletePortfolioByKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['key'] == null) {
            throw new runtime.RequiredError(
                'key',
                'Required parameter "key" was null or undefined when calling deletePortfolioByKey().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["portfolios:write"]);
        }


        let urlPath = `/portfolios/by-key/{key}`;
        urlPath = urlPath.replace(`{${"key"}}`, encodeURIComponent(String(requestParameters['key'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete portfolio by key
     * Delete portfolio
     */
    async deletePortfolioByKey(key: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deletePortfolioByKeyRaw({ key: key }, initOverrides);
    }

    /**
     * Get a single portfolio by key
     * Get portfolio
     */
    async getPortfolioByKeyRaw(requestParameters: GetPortfolioByKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PortfolioRepresentation>> {
        if (requestParameters['key'] == null) {
            throw new runtime.RequiredError(
                'key',
                'Required parameter "key" was null or undefined when calling getPortfolioByKey().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["portfolios:read"]);
        }


        let urlPath = `/portfolios/by-key/{key}`;
        urlPath = urlPath.replace(`{${"key"}}`, encodeURIComponent(String(requestParameters['key'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PortfolioRepresentationFromJSON(jsonValue));
    }

    /**
     * Get a single portfolio by key
     * Get portfolio
     */
    async getPortfolioByKey(key: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PortfolioRepresentation> {
        const response = await this.getPortfolioByKeyRaw({ key: key }, initOverrides);
        return await response.value();
    }

    /**
     * Get all portfolio templates accessible for the current user
     * Get portfolio templates
     */
    async getPortfolioTemplatesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PortfolioTemplateRepresentation>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["portfolios:read"]);
        }


        let urlPath = `/portfolios/templates`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PortfolioTemplateRepresentationFromJSON));
    }

    /**
     * Get all portfolio templates accessible for the current user
     * Get portfolio templates
     */
    async getPortfolioTemplates(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PortfolioTemplateRepresentation>> {
        const response = await this.getPortfolioTemplatesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get all portfolios for the current user
     * Get portfolios
     */
    async getPortfoliosRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PortfolioRepresentation>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["portfolios:read"]);
        }


        let urlPath = `/portfolios`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PortfolioRepresentationFromJSON));
    }

    /**
     * Get all portfolios for the current user
     * Get portfolios
     */
    async getPortfolios(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PortfolioRepresentation>> {
        const response = await this.getPortfoliosRaw(initOverrides);
        return await response.value();
    }

    /**
     * Remove a list of Generators from a portfolio
     * Remove generators
     */
    async removeGeneratorsRaw(requestParameters: RemoveGeneratorsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['key'] == null) {
            throw new runtime.RequiredError(
                'key',
                'Required parameter "key" was null or undefined when calling removeGenerators().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["portfolios:write"]);
        }


        let urlPath = `/portfolios/by-key/{key}/generators/remove`;
        urlPath = urlPath.replace(`{${"key"}}`, encodeURIComponent(String(requestParameters['key'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Remove a list of Generators from a portfolio
     * Remove generators
     */
    async removeGenerators(key: string, requestBody?: Array<string>, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeGeneratorsRaw({ key: key, requestBody: requestBody }, initOverrides);
    }

    /**
     * Update an existing portfolio
     */
    async updatePortfolioRaw(requestParameters: UpdatePortfolioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PortfolioRepresentation>> {
        if (requestParameters['key'] == null) {
            throw new runtime.RequiredError(
                'key',
                'Required parameter "key" was null or undefined when calling updatePortfolio().'
            );
        }

        if (requestParameters['portfolioUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'portfolioUpdateRequest',
                'Required parameter "portfolioUpdateRequest" was null or undefined when calling updatePortfolio().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["portfolios:write"]);
        }


        let urlPath = `/portfolios/by-key/{key}`;
        urlPath = urlPath.replace(`{${"key"}}`, encodeURIComponent(String(requestParameters['key'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PortfolioUpdateRequestToJSON(requestParameters['portfolioUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PortfolioRepresentationFromJSON(jsonValue));
    }

    /**
     * Update an existing portfolio
     */
    async updatePortfolio(key: string, portfolioUpdateRequest: PortfolioUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PortfolioRepresentation> {
        const response = await this.updatePortfolioRaw({ key: key, portfolioUpdateRequest: portfolioUpdateRequest }, initOverrides);
        return await response.value();
    }

}
